<template>
  <div>
    <special-index v-show="special && special['index/index']" :page-path="'index/index'" :item-id="''"></special-index>

    <div class="container" v-show="!special || !special['index/index']">

      <home-common-search :from='"home"'></home-common-search>

      <index-banner v-if="banners && banners.length > 0" :items="banners"></index-banner>

      <!-- <index-menu :items="navs"></index-menu> -->

      <!-- <index-article :items="articles"></index-article> -->

      <!-- <mt-swipe class="banner" style="height: 4rem;margin: .4rem .7rem 1rem;" :speed="600" :show-indicators="false">
        <mt-swipe-item>
          <img src="../../../assets/image/home/gobuy.png" @click="gotobuy" alt="gobuy">
        </mt-swipe-item>
        <mt-swipe-item>
          <img src="../../../assets/image/member/Recycle.png" @click="goGiftSave" alt="Recycle">
        </mt-swipe-item>
      </mt-swipe> -->

      <div class="tabs">
        <div class="tab active">{{ $t('Category') }}</div>
      </div>

      <CategoryCarousel v-if="class_list.length > 0" :data="class_list" />

      <index-three-ads :items="promotionAds"></index-three-ads>

      <div class="tabs">
        <div class="tab" v-for="(item, index) in tabs" :key="index" :class="{ active: index === activeTab }"
          @click="tabClick(item, index)">{{ $t(item.gc_name) }}</div>
      </div>

      <index-floor-ads v-if="floorAds" :ad="floorAds[0]"></index-floor-ads>

      <index-product-list :items="list" :type="popular" v-if="list && list.length > 0"></index-product-list>

      <index-floor-ads v-if="floorAds" :ad="floorAds[1]"></index-floor-ads>

      <!-- <index-product-list :items="hotProducts" title="销量排行" :type="sale"
        v-if="hotProducts && hotProducts.length > 0"></index-product-list>

      <index-floor-ads v-if="floorAds" :ad="floorAds[2]"></index-floor-ads>

      <index-product-list :items="recentlyProducts" title="新品上架" :type="recently"
        v-if="recentlyProducts && recentlyProducts.length > 0"></index-product-list> -->

      <!-- <div class="lang" @click="setLang">
        <img src="../../../assets/image/lang.png" alt="">
      </div> -->

      <!-- popup -->
      <mt-popup v-model="popupVisible" popup-transition="popup-fade" position="bottom">
        <div class="picker-toolbar-title">
          <div class="usi-btn-cancel" @click="popupVisible = !popupVisible">
            {{ $t('MessageBox.Cancel') }}
          </div>
          <div class="">{{ $t('Language selection') }}</div>
          <div class="usi-btn-sure" @click="addrConfirm">{{ $t('MessageBox.Confirm') }}</div>
        </div>
        <mt-picker ref="picker" :slots="slots" value-key="en" :itemHeight="50" @change="onValuesChange"
          v-if="slots[0].values.length > 0" @touchmove.native.stop.prevent></mt-picker>
      </mt-popup>
    </div>

    <audio src="../../../assets/image/gobuy/44s.mp3" muted style="display: none;"></audio>
    <audio src="../../../assets/image/gobuy/15s.mp3" muted style="display: none;"></audio>
  </div>
</template>

<script>
import { Goodsclass, GoodsList, goods_index_list, get_contact_info, getLangList, change_lang } from '../../../api/homeindex'
import { getAddressInfo } from '../../../api/memberBuy'
import axios from 'axios';
import store from '../../../store'
import { mapState, mapActions } from 'vuex'
import { Toast } from 'mint-ui'
import SpecialIndex from '../special/Index'
import IndexProductList from './IndexProductList'
import HomeCommonSearch from '../common/HomeCommonSearch'
import IndexBanner from './IndexBanner'
import IndexMenu from './IndexMenu'
import IndexFloorAds from './IndexFloorAds'
import IndexThreeAds from './IndexThreeAds'
import IndexArticle from './IndexArticle'
import CategoryCarousel from './CategoryCarousel'
export default {
  name: 'HomeIndex',
  data() {
    return {
      isshowBacktop: true,
      popular: '',
      sale: 'goods_salenum',
      recently: 'goods_addtime',
      tabs: [
        {
          gc_name: 'TodaysOffer'
        }
      ],
      activeTab: 0,
      list: [],
      // ECharts 实例
      chartInstance: null,
      slots: [
        {
          values: []
        }
      ],
      popupVisible: false,
      class_list: [],
      address_info: null,
    }
  },
  components: {
    SpecialIndex,
    IndexProductList,
    HomeCommonSearch,
    IndexBanner,
    IndexMenu,
    IndexFloorAds,
    IndexThreeAds,
    IndexArticle,
    CategoryCarousel
  },
  mounted() {
    getAddressInfo().then(res => {
      if (res.code == 10000) {
        this.address_info = res.result
      }
    })

    Goodsclass().then(res => {
      // for (let i = 0; i < res.result.length; i++) {
      //   this.tabs.push(res.result[i])
      // }
      this.class_list = res.result

      this.getList()
    })

    // console.log('fetchMessageCount');
    // this.fetchMessageCount();
  },
  created: function () {
    this.utils.preloadImages(['https://ysmhh.s3.amazonaws.com/1.gif', 'https://ysmhh.s3.amazonaws.com/2.gif'])


    this.fetchHomeAd({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.fetchHomeArticle({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.fetchHomeProduct({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.fetchConfig({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
  },
  computed: {
    ...mapState({
      special: state => state.home.special,
      config: state => state.config.config,
      banners: state => state.home.banners,
      navs: state => state.home.navs,
      floorAds: state => state.home.floorAds,
      promotionAds: state => state.home.promotionAds,
      articles: state => state.home.articles,
      hotProducts: state => state.home.hotProducts,
      recentlyProducts: state => state.home.recentlyProducts,
      goodProducts: state => state.home.goodProducts
    })
  },
  methods: {
    ...mapActions({
      fetchHomeAd: 'fetchHomeAd',
      fetchHomeArticle: 'fetchHomeArticle',
      fetchHomeProduct: 'fetchHomeProduct',
      fetchConfig: 'fetchConfig'
    }),
    getEmail() {
      this.$router.push({ name: 'MemberContactUs' })
    },
    tabClick(item, index) {
      this.activeTab = index

      this.getList(item.id)
    },
    getList(id) {
      goods_index_list(id).then(res => {
        this.list = res.result.goods_list
      })
      // GoodsList(id).then(res => {
      //   this.list = res.result.goods_list
      // })
    },
    gotobuy() {
      this.$router.push({ name: 'HomeGoBuy' })
    },
    goGiftSave() {
      this.$router.push({
        name: 'GiftSave'
      })
    },
    setLang() {
      // this.popupVisible = true;
      this.$router.push({ name: 'HomeLang' })
    },
    onValuesChange(picker, values) {
      this.product = values[0].en;
    },
    addrConfirm() {
      console.log(this.product);
      // 本地存储
      if (this.product == 'en-us') {
        this.$i18n.locale = 'en'
        this.utils.save('lang', 'en')
        this.utils.save("locale", 'en');
      } else {
        this.$i18n.locale = this.product
        this.utils.save('lang', this.product)
        this.utils.save("locale", this.product);
      }
      // 切换语言
      this.change_lang(this.product)
      this.popupVisible = false;
    },
    change_lang(lang) {
      change_lang(lang).then(res => {
        this.getLangList()
      })
    },
    getLangList() {
      getLangList().then(res => {
        this.slots[0].values = res.result
      })
    },
  }
}
</script>

<style scoped lang="scss">
.container {
  background: #fff;
  padding-bottom: 1px;
}

.tabs {
  padding-left: .7rem;
  padding-right: .7rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 .5rem;
  height: 1.5rem;
  background: #fff;
  margin: 2rem 0;

  .tab {
    // flex: 1;
    text-align: center;
    font-size: $fontSize;
    color: #333;
    padding: 7px 16px;
  }

  .active {
    // color: #fff;
    // background: #FB2933;
    // border-radius: 10px 10px 10px 10px;    
    display: inline-block;
    font-size: 28px;
    font-weight: 700;
    padding: 0 50px;
  }
}

.banner_ {
  margin: 0 10px 30px;

  img {
    width: 100%;
    height: 100%;
  }
}

.lang {
  // position: fixed;
  top: 5px;
  right: 5px;
  z-index: 99;

  img {
    width: 1.5rem;
  }
}

.picker-toolbar-title {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  background: #f5f5f5;
}

.usi-btn-cancel,
.usi-btn-sure {
  color: #108ee9;
}

::v-deep .product-list-header {
  // padding-left: 0;
  // padding-right: 40px;

  .slot {
    width: 4.5rem !important;
    // display: none;
  }
}

::v-deep .picker {
  .picker-items {
    width: 100%;
  }

  .picker-slot {
    flex: 1;
  }
}

.banner {

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
